<template>
  <div>
    <div v-if="user && selectedTime ">
      <div style="" class="wh">
        <div v-if="$vuetify.breakpoint.mdAndUp">
          <v-row justify="center" class="mt-5">
            <v-col cols="11">
              <div class="breadcrumb d-flex" v-if="$vuetify.breakpoint.mdAndUp">
                <div class="breadcrumbItem greenItem">
                  <a href="https://simiaroom.com" target="_blank" st>
                    سیمیاروم
                  </a>
                </div>
                <div class="mx-4">
                  /
                </div>
                <div class="breadcrumbItem greenItem" @click="changeStateFlow">
                  درمانگران پیشنهادی
                </div>
                <div class="mx-4">
                  /
                </div>
                <div class="breadcrumbItem">
                  دکتر
                  {{ therapist.user.full_name }}
                </div>
              </div>
              <div>
                <v-row class="mt-5">
                  <v-col cols="12" lg="3" class="">
                    <DoctorSideBar :therapist="therapist"/>
                  </v-col>
                  <v-col cols="12" lg="9" class="">
                    <div class="contextBox">
                      <div class="titleBox">
                        انتخاب زمان
                      </div>
                      <div class="bodyContext">

                        <div class="personalInfo">
                          <div class="titleForm">
                            لطفا نام خود را وارد کنید ( در صورت تمایل می توانید از نام و نام خانوادگی مستعار استفاده کنید)
                          </div>
                          <v-form ref="profile">
                            <v-row class=" mt-2">
                              <v-col class="customInputGrey" cols="12" lg="6">
                                <v-text-field :rules="requiredRules" v-model="user.firstname" outlined color="black"
                                              label="نام"></v-text-field>
                              </v-col>
                              <v-col class="customInputGrey" cols="12" lg="6">
                                <v-text-field v-model="user.lastname" outlined color="black"
                                              label=" نام خانوادگی (اختیاری)"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-form>
                        </div>
                        <!--                      <div class="customInputGrey">-->
                        <!--&lt;!&ndash;                        <v-autocomplete v-model="user.tz" @input="updateTz" :items="timezonesList" item-text="text"&ndash;&gt;-->
                        <!--&lt;!&ndash;                                        item-value="value"&ndash;&gt;-->
                        <!--&lt;!&ndash;                                        outlined&ndash;&gt;-->
                        <!--&lt;!&ndash;                                        color="black"&ndash;&gt;-->
                        <!--&lt;!&ndash;                                        label="انتخاب محدوده زمانی"></v-autocomplete>&ndash;&gt;-->
                        <!--                        -->
                        <!--                      </div>-->


                        <div style="border-bottom: 1px solid #F6F9FC"></div>

                      </div>
                      <div class="bodyContext timeArea">
                        <TimeCalendarWithTimezoneChange
                            @resetTimesBox="resetTimesBox"
                            @selectTime="selectTime($event)"
                            :selected-time="selectedTime"
                            :first-time="firstTime"
                            :times="times"
                            :show-doctor-time-instead-of-calendar-cta="true"
                        />
                      </div>
                      <div class="footerContext mt-4">
                        <v-row>
                          <v-col cols="12" lg="6">
                            <v-fade-transition>
                              <div class="sessionInfo d-flex flex-column justify-center  fill-height"
                                   v-if="selectedTime">
                                <div class="">
                                  {{ selectedTime.from_time | jalaliDateTime }}
                                  {{ selectedTime | getDayPeriodsLabel }}

                                  <span style="color:#035184;font-family: Roboto !important;">
                          ({{ profile.tz }})
                        </span>
                                </div>
                              </div>
                            </v-fade-transition>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <v-btn color="#39C990" @click="openModalConfirmSession" elevation="0"
                                   class="confirmBtn white--text" block>
                              تایید و ادامه
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>

          </v-row>
          <PreSessionBox type="blue"
                         class="mt-15"
                         text="چنانچه در پیدا کردن زمان مناسب چالش دارید، میتوانید با کارشناسان سیمیاروم در ارتباط باشید"
          />
        </div>
        <div class="mobileArea " v-else>
          <DoctorSideBar :therapist="therapist"/>
          <div class="whiteBox">
            <div class="mt-2">
              <div class="timezoneName">
                در صورت تمایل می توانید از نام و نام خانوادگی مستعار استفاده کنید
              </div>
              <v-form ref="profile">
                <div class="customInputGrey mt-2">
                  <v-text-field :rules="requiredRules" v-model="user.firstname" outlined color="black"
                                label="نام"></v-text-field>
                </div>
                <div class="customInputGrey">

                  <v-text-field v-model="user.lastname" outlined color="black"
                                label="نام خانوادگی (اختیاری)"></v-text-field>
                </div>
              </v-form>
            </div>
          </div>
          <div class="">
            <TimeCalendarWithTimezoneChange
                @resetTimesBox="resetTimesBox"
                @selectTime="selectTime($event)"
                :selected-time="selectedTime"
                :first-time="firstTime"
                :times="times"
                :show-doctor-time-instead-of-calendar-cta="true"
            >
              <template slot="bottomCalendar">
                <PreSessionBox type="blue"
                               class="mt-15"
                               text="چنانچه در پیدا کردن زمان مناسب چالش دارید، میتوانید با کارشناسان سیمیاروم در ارتباط باشید"
                               style="margin-bottom: 80px"/>
              </template>
            </TimeCalendarWithTimezoneChange>

          </div>
        </div>
        <div class="">

        </div>
      </div>


      <v-dialog width="620px" persistent v-model="confirmSession" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card style="padding: 16px 24px">
          <div class="headerModal d-flex justify-space-between">
            <div class="titleModal">
              تایید زمان جلسه
            </div>
            <div @click="confirmSession = false" style="cursor: pointer">
              <v-icon small>
                mdi-close
              </v-icon>
            </div>
          </div>
          <div class="greenBox d-flex mb-2 mt-5">
            <div class="ml-4">
              <img src="../../assets/image/user-journey/info-circle.svg" alt="">
            </div>
            <div>
              زمانی که انتخاب کردید تا
              <b>
                یک ساعت
              </b>
              برای شما رزرو می‌ماند ،
              در صورت عدم پرداخت، باید زمان جدیدی را انتخاب کنید.
            </div>
          </div>
          <div class="titleModalSection">
            آیا از زمان انتخاب شده برای برگزاری جلسه اول تراپی اطمینان دارید؟
          </div>
          <div class="doctorBox">
            <div class="doctorBoxHeader d-flex">
              <div>
                <img :src="therapist.user.avatar" width="84px" alt="">
              </div>
              <div class="d-flex flex-column justify-center mr-3">
                <div class="therapistName">
                  دکتر
                  {{ therapist.user.full_name }}
                </div>
                <div class="therapistSubtitle">
                  {{ therapist.subtitle }}
                </div>
              </div>
            </div>
            <div class="detailDoctor">
              <v-row class="">
                <v-col cols="12" lg="4">
                  <div class="d-flex ">
                    <div class="iconDetail d-flex  flex-column justify-center">
                      <img src="../../assets/image/user-journey/Time_Zone.svg" alt="">
                    </div>
                    <div class="nameDetail  d-flex flex-column justify-center">
                      منطقه زمانی:
                    </div>
                  </div>
                  <div class="valueDetail">
                    {{ profile.tz }}
                  </div>
                </v-col>
                <v-col cols="12" lg="4">
                  <div class="detailItem flex-column">
                    <div class="d-flex">
                      <div class="iconDetail d-flex flex-column justify-center">
                        <img src="../../assets/image/user-journey/calendar.svg" alt="">
                      </div>
                      <div class="nameDetail mx-1 d-flex flex-column justify-center">
                        تاریخ جلسه:
                      </div>
                    </div>
                    <div class="valueDetail">
                      {{ selectedTime.from_time | jalaliDateTimePartOne }}
                    </div>

                  </div>
                </v-col>
                <v-col cols="12" lg="4">
                  <div class="detailItem flex-column">
                    <div class="d-flex">
                      <div class="iconDetail d-flex flex-column justify-center">
                        <img src="../../assets/image/user-journey/clock.svg" alt="">
                      </div>
                      <div class="nameDetail mx-1 d-flex flex-column justify-center">
                        ساعت جلسه:
                      </div>
                    </div>
                    <div class="valueDetail">
                      {{ selectedTime.from_time | jalaliDateTimeWithoutLabel }}
                      {{ selectedTime | getDayPeriodsLabel }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="actionArea">
            <v-row>
              <v-col cols="6" class="pa-0 ma-0 px-1">
                <v-btn color="#39C990" elevation="0" @click="confirmTime" style="color: white !important;"
                       class="confirmBtn white--text"
                       block>
                  تایید و ادامه
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 px-1">
                <v-btn color="#39C990" @click="confirmSession = false" outlined elevation="0" class=" confirmBtnOutline"
                       block>
                  اصلاح زمان جلسه
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-dialog>

      <v-bottom-sheet fullscreen scrollable style="border-radius: 16px 16px 0px 0px;height: 100%"
                      v-model="confirmSession" v-if="$vuetify.breakpoint.mdAndDown">
        <div class="white" style="border-radius: 16px 16px 0px 0px;padding: 16px 24px">
          <div class="headerModal d-flex justify-space-between">
            <div class="titleModal">
              تایید زمان جلسه
            </div>
            <div @click="confirmSession = false" style="

          cursor: pointer">
              <v-icon small>
                mdi-close
              </v-icon>
            </div>
          </div>
          <div class="greenBox d-flex mb-2 mt-5">
            <div class="ml-4">
              <img src="../../assets/image/user-journey/info-circle.svg" alt="">
            </div>
            <div>
              زمانی ک انتخاب کردید تا
              <b>
                یک ساعت
              </b>
              برای شما رزرو می‌ماند،
              در صورت عدم پرداخت، باید زمان جدیدی را انتخاب کنید.
            </div>
          </div>
          <div class="titleModalSection">
            آیا از زمان انتخاب شده برای برگزاری جلسه اول تراپی اطمینان دارید؟
          </div>
          <div class="doctorBox ">
            <div class="doctorBoxHeader d-flex">
              <div>
                <img :src="therapist.user.avatar" width="84px" alt="">
              </div>
              <div class="d-flex flex-column justify-center mr-3">
                <div class="therapistName">
                  دکتر
                  {{ therapist.user.full_name }}
                </div>
                <div class="therapistSubtitle">
                  {{ therapist.subtitle }}
                </div>
              </div>
            </div>
            <div class="detailDoctor mt-2">
              <div class="detailItem">
                <div class="iconDetail d-flex flex-column justify-center">
                  <img src="../../assets/image/user-journey/Time_Zone.svg" alt="">
                </div>
                <div class="nameDetail mx-1 d-flex flex-column justify-center">
                  منطقه زمانی:
                </div>
                <div class="valueDetail">
                  {{ profile.tz }}
                </div>
              </div>
              <v-row class="mt-2">
                <v-col cols="12" lg="6">
                  <div class="detailItem">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/Time_Zone.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      تاریخ جلسه:
                    </div>
                    <div class="valueDetail">
                      {{ selectedTime.from_time | jalaliDateTimePartOne }}
                    </div>

                  </div>
                </v-col>
                <v-col cols="12" lg="6">
                  <div class="detailItem">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/Time_Zone.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      ساعت جلسه:
                    </div>
                    <div class="valueDetail">
                      {{ selectedTime.from_time | jalaliDateTimeWithoutLabel }}
                      {{ selectedTime | getDayPeriodsLabel }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="actionArea">
            <v-row>
              <v-col cols="6" class="pa-0 ma-0 px-1">
                <v-btn color="#39C990" @click="confirmTime" elevation="0" style="color: white !important;"
                       class="confirmBtn white--text"
                       block>
                  تایید و ادامه
                </v-btn>
              </v-col>
              <v-col cols="6" class="pa-0 ma-0 px-1">
                <v-btn color="#39C990" @click="confirmSession = false" outlined elevation="0" class=" confirmBtnOutline"
                       block>
                  اصلاح زمان جلسه
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </div>
      </v-bottom-sheet>

      <v-bottom-navigation height="80px" fixed class="bottomNavigation"
                           v-if="selectedTime && $vuetify.breakpoint.mdAndDown">
        <v-row>
          <v-col cols="6" class="pa-0 ma-0">
            <v-fade-transition>
              <div class="sessionInfo d-flex flex-column justify-center  fill-height" v-if="selectedTime">
                <div class="">
                  {{ selectedTime.from_time | jalaliDateTimePartOne }}
                  <br>
                  {{ selectedTime.from_time | jalaliDateTimePartTwo }}
                  {{ selectedTime | getDayPeriodsLabel }}
                  <br>
                  <span style="color:#035184;font-family: Roboto !important">
                          ( {{ profile.tz }} )
                        </span>

                </div>
              </div>
            </v-fade-transition>
          </v-col>
          <v-col cols="6" class="pa-0 ma-0 d-flex flex-column justify-center">
            <v-btn color="#39C990" @click="openModalConfirmSession" elevation="0"
                   style="color: white !important;"
                   class="confirmBtn white--text" block>
              تایید و ادامه
            </v-btn>
          </v-col>
        </v-row>
      </v-bottom-navigation>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import momentJalali from "moment-jalaali";
import {mapGetters} from "vuex";
import DoctorSideBar from "@/components/UserJourney/DoctorSideBar.vue";
import TimeCalendarWithTimezoneChange from "@/components/UserJourney/TimeCalendarWithTimezoneChange.vue";
import PreSessionBox from "@/components/UserJourney/PreSessionBox.vue";

/*eslint-disable*/
export default {
  components: {PreSessionBox, TimeCalendarWithTimezoneChange, DoctorSideBar},
  props: {
    therapist: Object,
    selectd_time: Object,
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    }),
    isDisabled() {
      return !this.user.firstname || !this.user.lastname
    },
    heightTimezoneBox() {
      return screen.height - 250 + "px"
    }
  },

  data() {
    return {
      confirmSession: false,
      timezoneParams: null,
      timezoneResultList: null,
      timezoneBottomSheet: false,
      user: null,
      tab: 'morning',
      isOpen: false,
      timezonesList: null,
      timeSelector: 'first_time',
      times: [],
      firstTime: null,
      selectedDay: null,
      selectedTime: null,
      timer: null,
      menuTimezoneIsOpen: false
    }
  },

  methods: {
    changeStateFlow() {
      this.$emit('changeStateFlow', {
        state: 'suggest_doctors'
      })
    },
    openModalConfirmSession() {
      if (this.profile.tz == 'UTC') {

        this.$emitEvent('notify', {title: 'لطفا محدوده زمانی خود را انتخاب کنید.', color: 'red'})
        return;
      }
      if (this.$refs.profile.validate()) {
        this.confirmTime()
      } else {
        this.$emitEvent('notify', {title: 'نام خود را وارد کنید', color: 'red'})
      }
    },
    resetTimesBox() {
      this.times = []
      this.selectedTime = null
      this.getTimes()
    },
    updateTz(tz) {
      let payload = {
        timezone: tz,
      }
      this.menuTimezoneIsOpen = false
      this.timezoneBottomSheet = false
      this.$emitEvent('setLoading', true)
      this.requesting('auth', 'editProfile', '', payload).then(() => {
        this.times = []
        this.selectedDay = null
        this.selectedTime = null
        this.getTimes()
        this.$emitEvent('notify', {color: 'green', title: 'موقعیت زمانی شما ویرایش شد', id: 'ga_login'});
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    },
    confirmTime() {
      this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 95)

      let data = {
        name: this.user.firstname,
        family: this.user.lastname,
      }
      this.requesting('auth', 'editProfile', '', data)

      this.$emit('changeStateFlow', {
        state: 'select_package',
        date_time_id: this.selectedTime.id,
      })

      this.$emit('selectTime', this.selectedTime)

      // this.changeStateFlow({
      //   time_id: time.id,
      //   state: 'select_time',
      // })
    },
    searchTimezone() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        console.log(this.timezoneParams)
        this.timezoneResultList = this.timezonesList.filter(i =>
            (i.text || "").toLowerCase().includes((this.timezoneParams || "").toLowerCase())
        )

        console.log(this.timezoneResultList)
      }, 500)

    },
    selectTime(time) {
      this.selectedTime = time
    },

    groupingTime(times) {
      this.reloadTime = true
      console.log(this.times, 'times')
      times.forEach((item) => {
        let date = momentJalali(item.date).format('YYYY-MM-DD')
        let time = this.times.find(i => i.date == date)
        if (!time) {
          this.times.push({
            date: date,
            id: item.id,
            periods: [item],
            morning: [],
            evening: [],
            night: [],
          })
        } else {
          time.periods.push(item)
        }
      })

      this.chunkTimesByPeriod(this.times)
    },
    chunkTimesByPeriod(times) {
      times.forEach(item => {
        item.periods.forEach((time) => {
          const hour = parseInt(momentJalali(time.from_time).format('HH'));
          if (hour) {
            if (hour >= 0 && hour < 12) {
              item.morning.push(time);
            } else if (hour >= 12 && hour < 18) {
              item.evening.push(time);
            } else if (hour >= 18 && hour <= 23) {
              item.night.push(time);
            }
          }
        })

      });
      this.reloadTime = false
    },
    getTimes() {
      this.times = []
      this.$emitEvent('setLoading', true)
      this.requesting("session", 'getDoctorTime', {doctorId: this.therapist.id}).then((resp) => {
        this.firstTime = resp.data.times[0]
        if (this.selectd_time) {
          this.selectedTime = this.selectd_time
          this.timeSelector = 'select_time'
        } else {
          this.selectedTime = resp.data.times[0]
        }
        if (!resp.data.times.find(item => item.id == this.selectedTime.id)) {
          this.selectedTime = this.firstTime
        }
        this.groupingTime(resp.data.times)
      }).finally(() => {
        this.$emitEvent('setLoading', false)
      })
    }
  },
  filters: {
    weekDayName(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("dddd");
    },
    getTime(dateStr) {
      momentJalali.loadPersian({dialect: 'persian-modern'});
      return momentJalali(dateStr).format("HH:mm");
    },
    getShortMonth(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").locale('en').format("MMM");
    },
    dayNumber(dateStr) {
      return moment(dateStr, "YYYY-MM-DD").format("DD");
    },
    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      console.log(hour, '1212')
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return 'شب'
        }
      }
    },
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD - [ساعت] hh:mm');
    },
    jalaliDateTimePartOne(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;

      return m.locale('fa').format('dddd YYYY/MM/DD ');
    },
    jalaliDateTimePartTwo(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format(' [ساعت] hh:mm');
    },
    jalaliDateTimeWithoutLabel(value) {
      if (!value) return '';
      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      if (!m.isValid()) return value;
      return m.locale('fa').format('  hh:mm');
    },

  },
  mounted() {
    this.getTimes()

    this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 95)

    setTimeout(() => {
      // this.$store.commit('SET_SEEK_BAR_USER_JOURNEY', 4)
    }, 1000)

    this.user = JSON.parse(JSON.stringify(this.profile))

    let times = JSON.parse(JSON.stringify(this.timezones));

    this.timezonesList = times.map((item) => {
      item.text = item.text + '  ' + moment.tz(item.text).format('Z');
      return item;
    });

    this.timezoneResultList = this.timezonesList
  },

}
</script>

<style>

@media (min-width: 200px) and (max-width: 1000px) {
  .mobileArea {
    //margin-bottom: 100px;
  }

  .bodyContext {
    padding-top: 16px !important;
  }

  .titleItem {
    font-size: 16px !important;
  }

  .detailItem {
    font-size: 16px !important;
  }

  .daysArea {
    overflow-y: scroll;
    width: 100% !important;
    padding: 0px 0px 10px 10px;
  }

  .dayBox {
    width: 84px !important;
  }

  .dayName {
    font-size: 16px !important;
  }

  .dateName {
    font-size: 14px !important;
  }

  .dayBoxList > * {
    flex: 0 0 80px !important;
  }

  .timeBlock {
    width: 100% !important;
    font-size: 11px !important;
    height: 40px !important;
    padding: 0px 8px !important;
    margin-left: 0px !important;
  }

  .sessionInfo {
    font-size: 13px !important;
  }

  .confirmBtn {
    height: 48px !important;
    font-size: 16px !important;
    color: white !important;
    border-radius: 8px !important;
  }

}

.timeZoneMenu {
  position: absolute;
  top: 35px;
  left: 0px;
  width: 356px;
  border-radius: 8px;
  border: 1px solid #EEE;
  background: #FFF;
  z-index: 1;
}

.actionArea {
  margin-top: 40px;
  margin-bottom: 16px;
  padding: 0px 5px;
}

.detailDoctor {
  padding: 16px;
  border-radius: 8px;
  background: #F6F9FC;
}


.therapistName {
  color: #212121;
  font-size: 20px;
  font-weight: 700;
}

.therapistSubtitle {
  color: #616161;
  font-size: 18px;
  font-weight: 500;
}

.doctorBox {
  border-radius: 8px !important;
  border: 1px solid #DBE4ED;
  padding: 16px;
  margin-top: 16px;
}

.titleModalSection {
  font-size: 18px;
  font-weight: 500;
  margin-top: 24px;
}


.greenBox {
  color: #30A778;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border-radius: 8px !important;
  border: 1px solid #39C990;
  background: rgba(215, 244, 233, 0.50);
  border-radius: 8px;
  padding: 14px 16px;

}

.v-dialog:not(.v-dialog--fullscreen) {
  border-radius: 16px !important;
}

.headerModal {
  padding-bottom: 16px;
  border-bottom: 1px solid #EAF0F6;
}

.titleModal {
  font-size: 18px;
  font-weight: 700;
}

.v-card > *:first-child:not(.v-btn):not(.v-chip):not(.v-avatar), .v-card > .v-card__progress + *:not(.v-btn):not(.v-chip):not(.v-avatar) {
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}


.bottomNavigation {
  box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40) !important;
  padding: 16px 24px;
}


.dayBoxList > * {
  flex: 0 0 110px;
}


.timezoneList {
  overflow-y: auto;
  margin-top: -20px;
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
}

.searchBoxArea {
  padding: 16px 16px 0px 16px;
}

.timeZoneItem {
  display: flex;
  border-bottom: 1px solid #F5F5F5;
}

.timeZoneItem > div {
  padding: 16px;
}

.timezoneLine {
  width: 5px;
  height: 50px;
  border-radius: 10px;
  transition: all 0.3s;
  cursor: pointer;
}

.timeZoneItem:hover .timezoneLine {
  background: #EAF0F6;
  transition: all 0.3s;
}

.timezoneImage {
  display: flex;
  flex-direction: column;
  padding: 16px 8px 0px 8px;
}

.timezoneName {
  padding: 16px 0px 0px 16px;
  margin-right: 8px;
  color: #424242;
  text-align: right;

  /* Body/Small/Medium14 */
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
}

.timezoneSearchArea {
  padding: 16px 24px;
}

.headerBottomSheet {
  padding: 16px 24px;
  border-bottom: 1px solid #EAF0F6;
}


.titleBottomSheet {
  font-size: 18px;
  color: #212121;
  font-weight: 500;
}

.timezoneName {
  color: #424242;
  text-align: right;
  font-size: 16px;
  font-family: "YekanBakh", "Roboto" !important;
  font-weight: 500;
}

.actionTimezone {
  color: #035184;
  font-weight: 500;
  font-size: 16px;
}

.timezoneName {
  color: #424242;
  text-align: right;
  font-size: 16px;
  font-weight: 500;
}

.titleWhiteBox {
  color: #616161;
  font-size: 14px;
  font-weight: 500;
}

.whiteBox {
  margin-top: 8px;
  background: white;
  padding: 10px 24px;
}

.activeDayBox {
  border-radius: var(--Space-3, 8px);
  border-color: #39C990 !important;
  background: linear-gradient(180deg, #FFF 0%, rgba(215, 244, 233, 0.80) 100%) !important;
  transition: all 0.3s;
}

.selectedDay {
  min-height: 150px;
}


.timeBlock {
  border-radius: var(--Space-3, 8px);
  border: 1px solid var(--Bluegray-bluegray-lighten-3, #DBE4ED);
  background: var(--shades-white, #FFF);
  height: 48px;
  padding: 0px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 8px;
  width: 130px;
  cursor: pointer;
  transition: all 0.3s;
}

.activeTimeBlock {
  border: 1px solid var(--Primary-Main, #39C990) !important;
  background: linear-gradient(180deg, #FFF 1.44%, #D7F4E9 100%) !important;
  color: #39C990;
  transition: all 0.3s;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #757575 !important;;
  font-weight: 700;

}

.v-tab--active {
  font-weight: 700;
  color: #39C990 !important;
}

.dayBox {
  border-radius: var(--Space-3, 8px);
  border: 1px solid var(--Bluegray-bluegray-lighten-3, #DBE4ED);
  background: var(--shades-white, #FFF);
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  text-align: center;
  margin-left: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.dayBox:hover {
  background: #F6F9FC;
  transition: all 0.3s;
}

.dayName {
  color: var(--grey-grey-darken-2, #616161);
  text-align: center;
  /* Body/Large/Medium18 */
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.dateName {
  font-family: "YekanBakh", "Roboto" !important;
  color: var(--grey-grey-darken-2, #616161);
  text-align: center;
  font-size: var(--Font-Size-lg, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.sessionCount {
  color: var(--Error-400, #FF5252);
  text-align: center;
  /* Body/Small/Medium14 */
  font-size: var(--Font-Size-md, 14px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 171.429% */
}


.confirmBtn {
  height: 50px !important;
  font-size: var(--Font-Size-Xl, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
  margin: 0px auto !important;
  width: 100% !important;
}

.confirmBtnOutline {
  height: 50px !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-radius: 8px;
  width: 100% !important;

}

.sessionInfo {
  color: var(--grey-grey-darken-3, #424242);
  /* Body/Large/Medium18 */
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.footerContext {
  box-shadow: 0 -2px 4px 0 rgba(219, 228, 237, 0.40);
  padding: 16px 24px;
}


.detailItem {
  color: var(--grey-grey-darken-2, #616161);
  /* Body/Large/Medium18 */
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.timeItem {
  border-radius: var(--Space-3, 8px);
  border: 1px solid var(--Bluegray-bluegray-lighten-2, #EAF0F6);
  background: var(--shades-white, #FFF);
  padding: var(--Space-4, 12px) 16px;
  transition: all 0.3s;

}

.titleItem {
  color: var(--grey-grey-darken-3, #424242);
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.titleForm {
  color: var(--grey-grey-darken-4, #212121);
  text-align: right;
  /* Body/Large/Medium18 */
  font-family: var(--Font-Family-Dashboard, "Yekan Bakh FaNum");
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;

}

.customInputGrey .v-text-field fieldset, .v-text-field .v-input__control {
  border-color: #DBE4ED !important;
  border-radius: 8px !important;
}

.titleBox {
  color: var(--grey-grey-darken-4, #212121);
  text-align: right;
  font-size: var(--Font-Size-2xl, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 16px 24px;
  border-bottom: 1px solid #DBE4ED;
  margin-bottom: 24px;
}

.bodyContext {
  padding: 0px 24px 16px 24px;

}

.contextBox {
  border-radius: 16px;
  border: 1px solid #DBE4ED;
  background: #FFF;
}


.titleSectionv2 {
  text-align: right;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}


.arrowBack img {
  width: 24px;
  margin: 0px auto;
}

.greenItem {
  color: #39C990 !important;
  cursor: pointer;
  text-decoration: none;
}

.greenItem a {
  text-decoration: none;

}


.breadcrumbItem {
  color: #757575;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.valueDetail {
  font-family: "YekanBakh", "Roboto" !important;
  color: #212121;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  //margin-top: 5px;
  line-height: normal;
}

</style>